import { getAdmin } from "../axios/api/AdminBaseUrl"

export const permissions ={
    getMyPermissions:{
        key:"getMyPermissions",
        call: () => {
            return getAdmin(`/auth/user_permissions/`)
          }
    },
  
    }